// extracted by mini-css-extract-plugin
export default {"root":"G8vYEFsE8J","root_selected":"rNva_JlWJw","header":"yRZfOcJ_uE","title":"TS0slkOU99","iconWrapper":"s5Pakggjyx","description":"A9pc8IF3UP"};